module.exports = __webpack_public_path__ + "static/media/Katrine.eb05f640.png";